export default __webpack_public_path__ + "static/media/check-icon-green.cc30950a.svg";